import { IconProps } from "./types";

const DuckLoadingSpinnerIcon = ({ size }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 19 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5235_118772)">
      <path
        d="M16.3634 8.40984C15.8373 5.11466 12.9648 2.59563 9.49995 2.59563C6.03515 2.59563 3.16275 5.11466 2.63663 8.40984L-9.14467e-07 8.40984C0.544317 3.67657 4.58992 -6.29884e-07 9.49995 -4.1526e-07C14.41 -2.00636e-07 18.4557 3.67656 19 8.40984L16.3634 8.40984Z"
        fill="#FF6467"
      />
      <path
        d="M18.9873 10.694C18.3962 15.3771 14.374 19 9.49995 19C4.62589 19 0.603763 15.3771 0.012654 10.694L2.65409 10.694C3.22337 13.9381 6.07164 16.4044 9.49995 16.4044C12.9283 16.4044 15.7766 13.9381 16.3459 10.694L18.9873 10.694Z"
        fill="#DBB1FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_5235_118772">
        <rect width="19" height="19" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default DuckLoadingSpinnerIcon;
